import styled, { ITheme } from '../../theme'

const FormSectionTitle = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  border-bottom: 1px solid
    ${(props: ITheme) => props.theme.colors.palette.greyTwo};
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
  padding-bottom: 12px;
`

export default FormSectionTitle
